<template>
  <wv-steak-house-default-section :section="section" :menu="menu"
                                  class="menu--section-cocktail"></wv-steak-house-default-section>
</template>

<script lang="ts">
/**
 * Special component for WV Steak House cocktail section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - Copy <WvSteakHouseCocktailSection> component from <WvSteakHouseDessertSection>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <WvSteakHouseCocktailSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  components: {
    WvSteakHouseDefaultSection,
  },
  name: "WvSteakHouseCocktailSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-cocktail,
.visual_menu--container-landscape .menu--section-cocktail {
  max-width: 522px;
  padding-left: 0;
  padding-right: 0;
  margin-left: auto;
  margin-right: auto;
}

.menu--section-cocktail:deep(.menu--section_title) {
  font-size: 1.6em;
  margin-bottom: 1em;
  padding-right: 0;
}


.menu--section-cocktail:deep(.menu--item_subgroup) {
  grid-gap: 0.35em;
}

.menu--section-cocktail:deep(.menu--section_subgroup_title) {
  margin-top: 1em;
  margin-bottom: 0;
  padding-right: 0;
  font-size: 1.3em;
}

.menu--section-cocktail:deep(.visual_menu--page_section) {
  padding-right: 0;
}

.menu--section-cocktail:deep(.menu--item_description) {
  margin-left: 0;
}
</style>